import HeroFrame from "../components/HeroFrame.jsx";
import Statement from "../components/Statement.jsx";
import WhatWeDo2 from "../components/WhatWeDo2.jsx";
import Method from "../components/Method.jsx";
import OurWorks from "../components/OurWorks.jsx";
import Team from "../components/Team.jsx";
import FAQ from "../components/FAQ.jsx";
import Testimonial2 from "../components/Testimonial2.jsx";
import useDocumentMeta from "../hooks/useDocumentMeta.js";

export default function HomePage() {
  useDocumentMeta();

  return (
    <>
      {/* hero stays pinned while the statement scrolls up over it */}
      <div className="hero-stack">
        <HeroFrame />
        <Statement />
      </div>
      <WhatWeDo2 />
      <Method />
      <OurWorks />
      <Testimonial2 />
      <Team />
      <FAQ />
    </>
  );
}
